import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import Category from "@/pages/category/page";
import News from "@/pages/news/page";
import Detail from "@/pages/detail/page";
import Article from "@/pages/article/page";
import Search from "@/pages/search/page";
import About from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "category/:type",
        element: <Category />,
      },
      {
        path: "news/:category",
        element: <News />,
      },
      {
        path: "detail/:id",
        element: <Detail />,
      },
      {
        path: "article/:id",
        element: <Article />,
      },
      {
        path: "search",
        element: <Search />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;